import { Logo } from '@/shared/components/logo';
import { Link } from 'react-router-dom';

interface SidebarHeaderProps {
  trigger: React.RefObject<HTMLButtonElement | null>;
  setSidebarOpen: (open: boolean) => void;
  sidebarOpen: boolean;
}
export function SidebarHeader({ trigger, setSidebarOpen, sidebarOpen }: SidebarHeaderProps) {
  return (
    <div className="flex justify-between mb-10 pr-3 sm:px-2">
      {/* Close button */}
      <button
        ref={trigger}
        className="lg:hidden text-gray-500 hover:text-gray-400"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-controls="sidebar"
        aria-expanded={sidebarOpen}
      >
        <span className="sr-only">Close sidebar</span>
        <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
        </svg>
      </button>

      <Logo />
    </div>
  );
}
